export default __webpack_public_path__ + "static/media/Crawl-e.300989d8.png";